module.exports = __webpack_public_path__ + "img/banner.2d1e21d.png";